module.exports = __webpack_public_path__ + "static/freshdesk-2e9bc42738bd3e8d5bd32aca8a280fba.png";